module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_17-b7419606544680747f5781b5621df9d8.png";